(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("sbCourseLearnerAccess", {
        templateUrl: "app/account/learnerAccess/learningItemType/sbCourseLearnerAccess.component.html",
        require: {
            parentCtrl: "^^learningItemLearnerAccessModal"
        },
        controller: ["assignmentLearnerAccessSBCourseResource", "messageService", "$rootScope", "$stateParams", "$uibModal", SbCourseLearnerAccessCtrl],
        controllerAs: "vm"
    });
    function SbCourseLearnerAccessCtrl(assignmentLearnerAccessSBCourseResource, messageService, $rootScope, $stateParams, $uibModal) {
        var vm = this;
        vm.code = $stateParams.code;
        this.$onInit = function () {
            vm.assignment = vm.parentCtrl.assignment;
            vm.parentCtrl.disableLaunchButton = false;
            vm.parentCtrl.requalifyClicked = false;
            load();
        };
        function load() {
            vm.model = assignmentLearnerAccessSBCourseResource.getLearnerAccessViewModel({ id: vm.assignment.id }, function () {
                //vm.lesson = model;
                vm.parentCtrl.contentLoaded = true;
                //if Path is Expiring or Expired, hide launch button.
                //If item has expired, show the requalify button, if disabled, disable the launch button
                if (vm.assignment.pathExpiryType === "Items" && (vm.assignment.assignmentStatus === 4 || vm.assignment.expiring)) {
                    vm.parentCtrl.buttons = "requalifyButton";
                    vm.parentCtrl.requalify = vm.requalify;
                }
                else if (vm.assignment.pathExpiringOrExpired) {
                    // Ignored
                }
                else {
                    if (vm.assignment.assignmentStatus === 0) {
                        //Disabled
                        vm.parentCtrl.disableLaunchButton = true;
                    }
                    else if (vm.assignment.assignmentStatus === 1) {
                        //Assigned
                    }
                    else if (vm.assignment.assignmentStatus === 2) {
                        //Activated
                        if (vm.model.timeToCompleteExpired)
                            vm.parentCtrl.disableLaunchButton = true;
                    }
                    else if (vm.assignment.assignmentStatus === 3) {
                        //Completed
                        if (!vm.model.accessAfterCompletion || vm.model.accessAfterCompletionExpired)
                            vm.parentCtrl.disableLaunchButton = true;
                    }
                    if (!vm.parentCtrl.disableLaunchButton) {
                        vm.parentCtrl.buttons = "launchButton";
                        vm.parentCtrl.launchCourse = vm.launchCourse;
                    }
                }
            }, function () {
                messageService.error("common.genericError");
            });
        }
        vm.launchCourse = function () {
            if (!vm.parentCtrl.disableLaunchButton) {
                if (vm.assignment.assignmentStatus > 0 && vm.assignment.assignmentStatus <= 3) {
                    //Activate Course
                    vm.launchValues = assignmentLearnerAccessSBCourseResource.launch({ id: vm.assignment.id }, function () {
                        vm.parentCtrl.dismiss();
                        //EXAMPLE: Request the token to refresh, so it won't expire during the course
                        $rootScope.$broadcast("refreshToken", openSBCourse);
                    });
                }
            }
        };
        vm.requalify = function () {
            vm.parentCtrl.requalifyClicked = true;
            vm.assignment.$requalify({ number: $stateParams.number, version: $stateParams.version, code: $stateParams.code }, function () {
                vm.launchCourse();
            }, function () {
                messageService.error("common.genericError");
            });
        };
        function openSBCourse() {
            var modalInstance = $uibModal.open({
                templateUrl: "/app/modals/learnerSBCourse/learnerViewSBCourseModalView.html",
                controller: "LearnerViewSBCourseModalCtrl as vm",
                resolve: {
                    launchValues: function () {
                        return vm.launchValues;
                    }
                }
            });
            modalInstance.result.then(function () {
                $rootScope.$broadcast("reloadQuickLinks");
                $rootScope.$broadcast("reloadLearningPath");
            }, function () {
                $rootScope.$broadcast("reloadQuickLinks");
                $rootScope.$broadcast("reloadLearningPath");
            });
        }
    }
}());
